// A PARTNER-PORTÁL feature-jogai — EGY helyen, a BFF fiókonkénti kapui és a web menü-/gomb-kapui is innen dolgoznak.
//
// A jog FIÓKONKÉNT érvényes: a partner szerepe fiókonként más lehet (A-n felhasználó, B-n megtekintő), és a szerep
// jog-tartalma a jogosultság-felületen szerkeszthető (alap-szerep, `seed`). A szerep → jog feloldást az Odin
// tokenje hordozza (`portal.roles`), ezért a kód SOHA nem a szerep NEVÉRE dönt, hanem a jogra.
//
// Ami NEM jog (alap-képesség minden portál-felhasználónak): a saját üzenetei, a saját profilja és a saját
// megbeszélés-meghívójára adott visszajelzés.
export const PORTAL_PERMISSIONS = {
    /** Jegyek: a fiók jegyeinek olvasása (lista, részlet, melléklet-letöltés). */
    ticketsView: 'portal.tickets.view',
    /** Jegy nyitása és válasz: minden jegy-írás (nyitás, válasz, szerkesztés, reakció, melléklet, hozzáférés-osztás). */
    ticketsWrite: 'portal.tickets.write',
    /** Szolgáltatások és díjak: az egész lap — havi terv/tény, szolgáltatások árral, számlák, tételek, PDF. */
    billingView: 'portal.billing.view',
    /** Fejlesztések: a termék-újdonságok lapja. */
    productUpdatesView: 'portal.product_updates.view',
};
/** Az összes portál feature-jog (a manifest-fal ezzel veti össze a katalógust). */
export const PORTAL_PERMISSION_KEYS = Object.values(PORTAL_PERMISSIONS);
//# sourceMappingURL=portal-permissions.js.map